module.exports = __webpack_public_path__ + "static/media/qualitypolicy-page-banner-1.4ed88f87.jpg";